import PageHeader from 'common/components/PageHeader/PageHeader';
import AlertsContext from 'common/contexts/alerts';
import useRouter from 'common/hooks/use-router';
import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TeamForm from 'requests/pages/Teams/TeamForm';
import useItem from '../../../common/hooks/useItem';

const Team = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const { id: teamId } = router.match.params;
  const {
    saveItem, updateItem, item, error,
  } = useItem('teams', teamId);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t('common.saved'), 'success');
      if (router.history.action === 'POP') {
        router.push('/teams');
      } else {
        router.history.goBack();
      }
    } else {
      setAlert(error, 'danger');
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(async (data) => {
    const team = { ...data };

    if (team.id) {
      await updateItem(team.id, team);
      back();
    } else {
      await saveItem(team);
      back();
    }
  }, [updateItem, back, saveItem]);

  return (
    <>
      <PageHeader
        title={t(`common.${item && item.id ? 'edit' : 'add'}`)}
        subLink={{
          url: '/teams',
          icon: 'arrow-left',
          goBack: true,
          label: t('common.back'),
        }}
      />
      <section className="section form-page has-cards">
        <TeamForm onSubmit={onSubmit} team={item} />
      </section>
    </>
  );
};

export default Team;
